import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { apiHolder as api, apis, getIn18Text } from 'api';
import styles from './index.module.scss';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const CommentModal = props => {
    const { mailId, memo = '', visible: commentVisible, setVisible: setCommentVisible, account } = props;
    const titleWords = memo ? getIn18Text('XIUGAI') : getIn18Text('TIANJIA');
    const title = `${titleWords}${getIn18Text('BEIZHU')}`;
    const [commentVal, setCommentVal] = useState(memo);
    const onCommentCancel = e => {
        e.stopPropagation();
        setCommentVisible(false);
    };
    const handleCommentOk = e => {
        e.stopPropagation();
        if (!mailId)
            return;
        mailApi
            .doMarkMail(false, mailId, 'memo', false, true, { memo: commentVal }, account)
            .then(() => {
            message.success(`${getIn18Text('YICHENGGONG')}${titleWords}${getIn18Text('BEIZHU')}`);
            setCommentVisible(false);
        })
            .catch(() => {
            message.fail(getIn18Text('BEIZHUSHIBAI', { titleWords }));
        });
    };
    return (React.createElement(Modal, { centered: true, title: title, width: 480, className: `${styles.readmailCommentModal} extheme`, visible: commentVisible, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), onCancel: onCommentCancel, bodyStyle: { overflow: 'auto' }, destroyOnClose: true, footer: [
            React.createElement(Button, { key: "cancel", onClick: onCommentCancel, className: "local-import-btn" }, getIn18Text('QUXIAO')),
            React.createElement(Button, { key: "confirm", type: "primary", onClick: handleCommentOk, disabled: !commentVal.length, className: "local-import-btn" }, getIn18Text('QUEDING')),
        ] },
        React.createElement(Input.TextArea, { showCount: true, placeholder: getIn18Text('QINGSHURUBEIZHUNR'), value: commentVal, onClick: e => e.stopPropagation(), onChange: e => setCommentVal(e.target.value), className: "readmail-comment", maxLength: 100 })));
};
export default CommentModal;
